import { AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';

import { getTechnologiesApi } from '../../api/Interviews/technologies.api';
import { GET_TECHNOLOGIES } from '../../constants/ActionTypes';
import { showAlert } from '../../actions/alert.action';
import { EAlertType } from '../../types/alert.types';
import { apiErrorHandler } from '../../utils/api-helpers';
import {
  TECHNOLOGIES_API_HTTP_STATUS_CODES,
  TECHNOLOGIES_ERROR_MESSAGE,
} from '../../constants/Interviews/TechnologiesConstants';

function* getTechnologies() {
  try {
    const getTechnologiesResp: AxiosResponse = yield call(getTechnologiesApi);
    yield put({
      type: `${GET_TECHNOLOGIES}_SUCCESS`,
      payload: {
        technologies: getTechnologiesResp.data.technologies,
      },
    });
  } catch (error: any) {
    const message: string | null = yield call(
      apiErrorHandler,
      error,
      TECHNOLOGIES_API_HTTP_STATUS_CODES,
      TECHNOLOGIES_ERROR_MESSAGE
    );
    if (message)
      yield put(
        showAlert({
          show: true,
          message,
          type: EAlertType.ERROR,
        })
      );
  }
}

export default function* loadTechnologiesSaga() {
  yield takeLatest(GET_TECHNOLOGIES, getTechnologies);
}
